import React, { useState } from 'react'
import { Tabs } from 'antd';
import { Button, Card } from 'antd';
import Master from './MasterView'
import GDSdata from './GDSdata'
const { TabPane } = Tabs;

const GDSinformation = (props: any) => {

  const [disabledFlag, setDisabledFlag] = useState<boolean>(false)
  const [editMode, setEditMode] = useState<boolean>(false)

  const disableTabPanes = (value: boolean) => {
    setDisabledFlag(value)
  }

  return (
    <div >
      <Tabs defaultActiveKey="1">
        <TabPane tab="GDS Information" key="1" disabled={disabledFlag}>
            
        <Card style={{position: 'initial', marginLeft:'16px', marginRight:'16px'}}>
                <Tabs type="card" defaultActiveKey='1'
                    tabBarExtraContent={ !editMode &&
                      <Button 
                        type='primary'
                        className="db-edit-btn"
                        onClick={ () => {setEditMode(true); props.isEditable(); disableTabPanes(true)} }
                      >
                        Edit
                      </Button>
                    }>
                    {/* <TabPane tab='Master' key='1' disabled={disabledFlag}>
                        <Master 
                          isEditable={props.isEditable} 
                          cancelEditable={props.cancelEditable} 
                          disableTabPanes={disableTabPanes}
                          setEditMode={setEditMode} 
                          editMode={editMode}
                          />
                    </TabPane> */}
                    <TabPane tab='Amadeus' key='2' disabled={disabledFlag}>
                        <GDSdata 
                            gdsName='Amadeus'
                            isEditable={props.isEditable} 
                            cancelEditable={props.cancelEditable} 
                            disableTabPanes={disableTabPanes}
                            setEditMode={setEditMode} 
                            editMode={editMode}/>
                    </TabPane>
                    <TabPane tab='Apollo/Galileo' key='3' disabled={disabledFlag}>
                        <GDSdata 
                            gdsName='Galileo'
                            isEditable={props.isEditable} 
                            cancelEditable={props.cancelEditable} 
                            disableTabPanes={disableTabPanes}
                            setEditMode={setEditMode} 
                            editMode={editMode}/>
                    </TabPane>
                    <TabPane tab='Sabre' key='4' disabled={disabledFlag}>
                        <GDSdata 
                            gdsName='Sabre'
                            isEditable={props.isEditable} 
                            cancelEditable={props.cancelEditable} 
                            disableTabPanes={disableTabPanes}
                            setEditMode={setEditMode} 
                            editMode={editMode}/>
                    </TabPane>
                    <TabPane tab='Worldspan' key='5' disabled={disabledFlag}>
                        <GDSdata 
                            gdsName='Worldspan'
                            isEditable={props.isEditable} 
                            cancelEditable={props.cancelEditable} 
                            disableTabPanes={disableTabPanes}
                            setEditMode={setEditMode} 
                            editMode={editMode}/>
                    </TabPane>
                    <TabPane tab='DHISCO/RateGain' key='6' disabled={disabledFlag}>
                        <GDSdata 
                            gdsName='Dhisco'
                            isEditable={props.isEditable} 
                            cancelEditable={props.cancelEditable} 
                            disableTabPanes={disableTabPanes}
                            setEditMode={setEditMode} 
                            editMode={editMode}/>
                    </TabPane>
                </Tabs>
            </Card>
        </TabPane>
      </Tabs>
    </div>
  )
}

export default GDSinformation;
